/**
 * Antrean konten, dibaca sebagai PEKERJAAN: satu konten satu baris, dan mana yang
 * menunggu orang. Dipakai lencana menu, Hari ini, dan layar Konten, supaya ketiganya
 * tidak bisa menyebut angka yang berbeda.
 */

// Tujuh hari ke depan dan tiga puluh ke belakang: jendela layar Konten. Lencana dan
// Hari ini memakai jendela yang sama supaya berbagi satu permintaan dengannya.
export const JENDELA_KONTEN = { hari: 7, mundur: 30 }

// Status terburuk menang saat satu konten punya beberapa tujuan: satu tujuan gagal
// sementara yang lain terbit harus terbaca "ada yang gagal".
const URUT_STATUS = ['failed', 'pending_concept', 'pending_approval', 'draft', 'scheduled',
  'published', 'rejected']

const SELESAI = ['published', 'rejected', 'scheduled']

/**
 * Satu konten ke dua platform adalah dua baris di database dan SATU baris di layar.
 * Digabung per `campaign_id`; yang tanpa campaign berdiri sendiri.
 */
export function gabungKonten(baris) {
  const peta = new Map()
  for (const k of baris ?? []) {
    const kunci = k.campaign_id || `sendiri:${k.id}`
    const ada = peta.get(kunci)
    if (!ada) {
      peta.set(kunci, { ...k, tujuan: [k] })
      continue
    }
    ada.tujuan.push(k)
    if (URUT_STATUS.indexOf(k.status) < URUT_STATUS.indexOf(ada.status)) ada.status = k.status
    // Jam terawal yang ditampilkan: itu yang paling dulu jatuh tempo.
    if (k.scheduled_at && (!ada.scheduled_at || k.scheduled_at < ada.scheduled_at)) {
      ada.scheduled_at = k.scheduled_at
    }
  }
  return [...peta.values()]
}

/** Konten yang menunggu orang: belum terbit, belum terjadwal, dan tidak ditolak. */
export function kontenMenunggu(gabungan) {
  return gabungan.filter((k) => !SELESAI.includes(k.status))
}

/**
 * Yang menunggu, dipilah menurut apa yang harus dilakukan orangnya. Jumlah kelimanya
 * sama dengan `kontenMenunggu(...).length`.
 */
export function rincianMenunggu(gabungan) {
  const r = { belumDijadwalkan: 0, konsep: 0, persetujuan: 0, gagal: 0, tanpaGambar: 0 }
  for (const k of kontenMenunggu(gabungan)) {
    if (k.status === 'failed') r.gagal += 1
    else if (k.status === 'pending_concept') r.konsep += 1
    else if (k.status === 'draft') r.tanpaGambar += 1
    else if (k.scheduled_at) r.persetujuan += 1
    else r.belumDijadwalkan += 1
  }
  return r
}
